<shared-box class="tile-for-loyalty-points" [contentHorizontalPaddings]="false" [contentVerticalPaddings]="false"
    [ngClass]="{'-loaded': !!loyaltyPoints && !loading}">
    <div class="tile-for-loyalty-points__inner">
        <div class="tile-for-loyalty-points__bd">
            <div class="tile-for-loyalty-points__content">
                <shared-header [ellipsis]="true" [brandAccent]="true" type="6" marginTop="none" marginBottom="xs"
                    [loading]="!loyaltyPoints || loading">
                    {{ loyaltyPoints?.header }}
                </shared-header>
                <shared-header [ellipsis]="true" type="3" marginTop="none" marginBottom="xs"
                    [loading]="!loyaltyPoints || loading">
                    <ng-container *ngIf="loyaltyPoints?.mode === 0">
                        {{ loyaltyPoints?.memberPoints | number: '1.0-' + loyaltyPoints?.roundUnits }} <span class="tile-for-loyalty-points__content--units">{{ loyaltyPoints?.units }}</span>
                    </ng-container>
                    <ng-container *ngIf="loyaltyPoints?.mode === 1">
                        ${{ loyaltyPoints?.dolarPoints | number: '1.0-' + loyaltyPoints?.roundUnits }}
                    </ng-container>
                </shared-header>
                <div *ngIf="loyaltyPoints?.mode === 1" class="tile-for-loyalty-points__desc">
                    Your balance is made up of {{ loyaltyPoints?.memberPoints | number: '1.0-' + loyaltyPoints?.roundUnits }} points
                </div>
            </div>
        </div>
    </div>
</shared-box>